import React, { useContext } from "react";
import { AppContext } from "../../../context";
import { ENTITIES } from "../../../entities/entitiesConfig";
import { languageName } from "../../../library/language";

function IconAndStoreName({ store }) {
  const { language } = useContext(AppContext);
  return (
    <div className="ahp-icon-and-name">
      {ENTITIES[store.type].icon}
      <p className="ahp-store-card-name">
        {languageName(store?.name, language)}
      </p>
    </div>
  );
}

export default IconAndStoreName;
